import * as React from 'react';

import {TwoLineInfo} from './two-line-info';

type Props = {
    territory: string;
};

export function LeadTerritory(props: Props) {
    return <TwoLineInfo header='Territory' body={props.territory} />;
}
